import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import { AddContainer, Component6, Texts, LabelWithTooltip } from './Style';
import SwitchComponent from 'src/components/shared/Form/Switch';
import { useDispatch } from 'react-redux';
import toast from 'src/utils/toast';
import { postCustomFieldsRequest, getCustomFieldsRequest } from '../../../store/appActions';

function CustomPatientFields({ innerRef, data, setClinicProfileData, clinicId }) {
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState({
    height: false,
    weight: false,
    postalAddress: true,
    area: true,
    city: true,
    state: true,
    aadhaarNumber: false,
    pulseRate: true,
    spo2: true,
    respiratoryRate: true,
    temperature: true,
  });

  const fields = [
    { key: 'height', label: 'Height', type: 'text' },
    { key: 'weight', label: 'Weight', type: 'number' },
    { key: 'postalAddress', label: 'Postal Address', type: 'text' },
    { key: 'area', label: 'Area', type: 'text' },
    { key: 'city', label: 'City', type: 'text' },
    { key: 'state', label: 'State', type: 'text' },
    { key: 'aadhaarNumber', label: 'Aadhaar card number', type: 'text' },
    { key: 'pulseRate', label: 'Pulse Rate', type: 'text' },
    { key: 'spo2', label: 'SpO2', type: 'text' },
    { key: 'respiratoryRate', label: 'Respiratory Rate', type: 'text' },
    { key: 'temperature', label: 'Temperature', type: 'text' },
  ];

  useEffect(() => {
    if (clinicId) {
      dispatch(getCustomFieldsRequest(clinicId, (res) => {
        if (res?.fields) {
          const newValues = {
            height: false,
            weight: false,
            postalAddress: false,
            area: false,
            city: false,
            state: false,



            aadhaarNumber: false,
            pulseRate: false,
            spo2: false,
            respiratoryRate: false,
            temperature: false,
          };
          res.fields.forEach(field => {
            if (newValues.hasOwnProperty(field.fieldName)) {
              newValues[field.fieldName] = true;
            }
          });
          setInitialValues(newValues);
        }
      }));
    }
  }, [clinicId, dispatch]);

  const handleSubmit = (values) => {
    setClinicProfileData((prev) => ({
      ...prev,
      customPatientFields: { ...values },
    }));

    const customFieldsPayload = {
      clinicId: clinicId,
      fields: fields
        .filter(field => values[field.key])
        .map(field => ({
          fieldName: field.key,
          label: field.label,
          type: field.type,
          required: false
        }))
    };

    return new Promise((resolve, reject) => {
      dispatch(postCustomFieldsRequest(customFieldsPayload, (res) => {
        toast.success('Custom patient fields updated successfully');
        resolve(res);
      }, (err) => {
        toast.error(err?.message || 'Failed to update custom patient fields');
        reject(err);
      }));
    });
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} innerRef={innerRef} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Form>
          <AddContainer>
            {fields.map(({ key, label }) => (
              <Component6 key={key}>
                <Texts>
                  <LabelWithTooltip label={label} tooltip={`Enable to collect ${label} during patient onboarding/registration.`} />
                </Texts>
                <SwitchComponent
                  name={key}
                  checked={Boolean(values[key])}
                  onChange={() => setFieldValue(key, !values[key])}
                  sx={{ margin: 0, padding: 0 }}
                />
              </Component6>
            ))}
          </AddContainer>
        </Form>
      )}
    </Formik>
  );
}

export default React.memo(CustomPatientFields);
